import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, watch } from 'vue'
  import type { PropType } from 'vue'
  import type { DropdownItem } from '@/services/interfaces/Common'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useEditor from '@/composables/useEditor'
  import { vOnClickOutside } from '@vueuse/components'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    items: {
      type: Array as PropType<DropdownItem[]>,
      default: () => [],
    },
    value: [String, Boolean, Number],
    headerTitle: {
      type: String,
      default: '',
    },
    dropdownPlaceholder: String,
    defaultDropdownBehavior: {
      type: Boolean,
      default: false,
    },
    strokeColorForExpandIcon: {
      type: String,
      default: '#999',
    },
    showAddItem: {
      type: Boolean,
      default: false,
    },
    addItemText: {
      type: String,
      default: '',
    },
    openDropdownByDefault: {
      type: Boolean,
      default: false,
    },
    hideToggleDropdown: {
      type: Boolean,
      default: false,
    },
    showEditItemIcon: {
      type: Boolean,
      default: false,
    },
    showCountryFlags: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'edit', 'delete', 'add-item'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const route = useRoute()
  const { expandMoreOptions, trashIcon, pencilIcon } = useIcons()
  const { decodeAndParseSource } = useEditor(route)

  const openDropdown = ref(props.openDropdownByDefault)
  const activeDropdownItem = ref('')

  const activeItem = computed((): DropdownItem | undefined => {
    return props.items.find((item) => item.type === selectedValue.value)
  })

  const selectedValue = computed({
    get(): string | boolean | number | undefined {
      return props.value
    },
    set(value: string | boolean | number | undefined) {
      emit('input', value)
    },
  })

  const itemCTAIsHovered = computed(
    () => (index: number) => itemCTAHoverState.value && itemCTAHoverState.index === index,
  )

  const countryIconCode = computed(() => (code: string | undefined) => {
    if (!code) return ''

    const parts = code.split('|')
    return parts.length > 1 ? parts[1] : code
  })

  const setItemsSelectedBefore = () => {
    props.items.forEach((item) => {
      if (item.selectedBefore) {
        activeDropdownItem.value = item.title
      }
    })
  }

  const closeDropdown = (callback?: () => void) => {
    setTimeout(() => {
      if (!props.openDropdownByDefault) {
        openDropdown.value = false
      }
      if (typeof callback === 'function') callback()
    }, 150)
  }

  const setOpenDropdown = () => {
    if (!props.openDropdownByDefault) {
      if (openDropdown.value) {
        closeDropdown()
      } else {
        openDropdown.value = true
      }
    }
  }

  const selectItem = (item: DropdownItem) => {
    if (item.selectable) {
      closeDropdown(() => {
        selectedValue.value = item.type as string
        activeDropdownItem.value = item.title
      })
    }
  }

  const itemCTAHoverState = reactive({
    index: 0,
    value: false,
  })
  const hoveringItemCta = (index: number, value: boolean) => {
    itemCTAHoverState.index = index
    itemCTAHoverState.value = value
  }

  watch(
    () => props.openDropdownByDefault,
    (value) => {
      if (value) {
        openDropdown.value = value
      }
    },
  )

  watch(
    () => props.items,
    () => {
      setItemsSelectedBefore()
    },
  )

return { __sfc: true,emit, props, route, expandMoreOptions, trashIcon, pencilIcon, decodeAndParseSource, openDropdown, activeDropdownItem, activeItem, selectedValue, itemCTAIsHovered, countryIconCode, setItemsSelectedBefore, closeDropdown, setOpenDropdown, selectItem, itemCTAHoverState, hoveringItemCta, computed, reactive, ref, watch, SVGRenderer, useIcons, useEditor, vOnClickOutside, useRoute }
}

})